export const MyMetadataTypeColumn = {
  field: 'type',
  title: 'Type',
  width: 200
};

export const MyMetadataNameColumn = {
  field: 'name',
  title: 'Name',
  width: 320
};

export const MyMetadataOptimizeStatusColumn = {
  field: 'optimizeStatus',
  title: 'Optimization',
  width: 170
};

export const MyMetadataDataPrivacyColumn = {
  field: 'data',
  title: 'Data privacy',
  width: 170
};

export const MyMetadataLinksColumn = {
  field: 'links',
  title: '# of links',
  width: 110
};

export const MyMetadataStatusColumn = {
  field: 'status',
  title: 'Status',
  width: 110
};

export const MyMetadataImpactColumn = {
  field: 'impact',
  title: 'Field impact',
  width: 150
};

export const MyMetadataTagsColumn = {
  field: 'tags',
  title: 'Tags',
  width: 400,
  minResizableWidth: 200
};

export const TAGS_PATH = 'tags';
export const OPTIMIZE_STATUS_PATH = 'sfNode.optimize.optimizeStatus.value';
